// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3WyhD","resendInfoText":"OnGoingPaymentBox_resendInfoText__3b4A3"};